import { OrganizationProfessionalConfigurationApi } from 'woofwoof-api';
import client, { axiosBaseUrl } from './client';

export const organizationProfessionalConfigApi = new OrganizationProfessionalConfigurationApi(
  {
    basePath: axiosBaseUrl,
    isJsonMime: () => false,
  },
  undefined,
  //@ts-ignore
  client,
);
